/* eslint-disable */
export default {
    pages: {
        key: "title",
        data: [
            { title: 'Home', url: '/', icon: 'HomeIcon', is_bookmarked: false },
            // { title: 'Institucion', url: '/instituciones', icon: 'FileIcon', is_bookmarked: false },
            // { title: 'Juegos', url: '/docente/juegos', icon: 'BoxIcon', is_bookmarked: false },
            // { title: 'Material de apoyo', url: '/lista/materialapoyoAdmin', icon: 'WindIcon', is_bookmarked: false },
            // { title: 'Actividades', url: '/listaActividades', icon: 'ApertureIcon', is_bookmarked: false },
            // { title: 'Cursos', url: '/listaCursos', icon: 'ServerIcon', is_bookmarked: false },
            // { title: 'Codigos libros', url: '/codigoslibros', icon: 'FileIcon', is_bookmarked: false },
            // { title: 'Banco preguntas', url: '/bancopreguntas', icon: 'SearchIcon', is_bookmarked: false },
            // { title: 'Artículos pedagógicos', url: '/publicaciones', icon: 'GridIcon', is_bookmarked: false },
            // { title: 'Proyectos', url: '/proyectosAdmin', icon: 'FolderIcon', is_bookmarked: false },
        ]
    }
}
/* eslint-enable */